import { setSpecificMessage, decimal } from "valibot";
setSpecificMessage(
  decimal,
  (issue) => `Décimale invalide: reçu ${issue.received}`,
  "fr"
);